module.exports = __webpack_public_path__ + "static/media/attachment.dc3f4701.svg";